import * as actionTypes from './actionTypes';

export const selectSavedSearch = ( savedSearch: any ) => {
  return {
      type: actionTypes.SAVED_SEARCH_SELECT,
      searchData: savedSearch
  };
};

export const clearSelectedSavedSearch = () => {
  return {
      type: actionTypes.SAVED_SEARCH_CLEAR_SELECTED,
  };
};

export const setSavedSearches = ( savedSearches: any ) => {
    return {
        type: actionTypes.SAVED_SEARCH_INIT,
        searchData: savedSearches
    };
};

export const removeSavedSearch = ( savedSearch: any ) => {
    return {
        type: actionTypes.SAVED_SEARCH_REMOVE,
        searchData: savedSearch
    };
};

export const addSavedSearch = ( savedSearch: any) => {
    return {
        type: actionTypes.SAVED_SEARCH_ADD,
        searchData: savedSearch
    };
};

export const setDefaultSavedSearch = ( savedSearch: any) => {
  return {
      type: actionTypes.SAVED_SEARCH_SET_DEFAULT,
      searchData: savedSearch
  };
};
